import type {
  PatinfoProfileDto,
  PatinfoSearchResultDto,
  PatinfoSearchTermDto,
} from '../../types/api/patinfo';

export interface ClientSearchValues {
  fname: string;
  lname: string;
  patid: string;
  dob: string;
  blocksize: string;
}

export const EMPTY_CLIENT_SEARCH_VALUES: ClientSearchValues = {
  fname: '',
  lname: '',
  patid: '',
  dob: '',
  blocksize: '10',
};

export const CLIENTS_TAB_CACHE_KEYS = {
  addClient: 'clients/add-client',
  manageClients: 'clients/manage-clients',
  recentReports: 'clients/recent-reports',
  openAdmins: 'clients/open-admins',
  manageFlags: 'clients/manage-flags',
  manageMessages: 'clients/manage-messages',
} as const;

export interface AddClientTabCache {
  lastSavedId: string | null;
  lastSaveResult: 'new' | 'exists' | null;
  lastError: string | null;
}

export interface ManageClientsTabCache {
  profiles: PatinfoProfileDto[];
  error: string | null;
  blocknum: string;
  blocksize: string;
  hasMore: boolean;
  lastTerms: PatinfoSearchTermDto[];
  hasSearched: boolean;
  searchValues: ClientSearchValues;
  saveSyncError: string | null;
}

export interface RecentReportsTabCache {
  results: PatinfoSearchResultDto[];
  profiles: PatinfoProfileDto[];
  error: string | null;
  blocknum: string;
  blocksize: string;
  hasMore: boolean;
  hasSearched: boolean;
  saveSyncError: string | null;
}

export interface OpenAdminsTabCache {
  profiles: PatinfoProfileDto[];
  error: string | null;
  blocknum: string;
  blocksize: string;
  hasMore: boolean;
  hasSearched: boolean;
  saveSyncError: string | null;
}

export interface ManageFlagsTabCache {
  profiles: PatinfoProfileDto[];
  error: string | null;
  blocknum: string;
  blocksize: string;
  hasMore: boolean;
  hasSearched: boolean;
  saveSyncError: string | null;
}

export interface ManageMessagesTabCache {
  profiles: PatinfoProfileDto[];
  error: string | null;
  blocknum: string;
  blocksize: string;
  hasMore: boolean;
  hasSearched: boolean;
  saveSyncError: string | null;
}
